{
  "nav": {
    "home": "Inicio",
    "tutorials": "Tutoriales",
    "contact": "Contactanos",
    "logout": "Logout",
    "logoAlt": "DinLabel",
    "download": "Descargar",
    "buy": "Comprar",
    "login": "Iniciar sesión",
    "myAccount": "Mi cuenta",
    "settings": "Configuración",
    "distributorPortal": "Portal de distribuidores"
  },
  "settings": {
    "title": "Configuración",
    "language": "Idioma",
    "languageDescription": "Elige el idioma de la aplicación. Por defecto se usa el idioma del navegador.",
    "languageBrowser": "Usar idioma del navegador",
    "languageEnglish": "Inglés",
    "languageSpanish": "Español",
    "languageGerman": "Alemán",
    "languageFrench": "Francés"
  },
  "offline": {
    "title": "Sin conexión",
    "message": "La aplicación no se puede conectar con el servidor :( !!"
  },
  "dialogs": {
    "apiError": "Error de Api",
    "confirmYes": "Sí",
    "cancel": "Cancelar",
    "send": "Enviar"
  },
  "portal": {
    "pageTitle": "Portal de distribuidores",
    "greeting": "Bienvenid@, {{name}}",
    "actions": "Acciones",
    "authorized": "Autorizado",
    "pending": "Pendiente de aprobación",
    "buyLicenses": "Comprar licencias",
    "pendingApproval": "Su solicitud de distribuidor todavia no ha sido aprobada - para cualquier pregunta, puede contactar a {{email}}. Este proceso no debe tardar más de 2 dias habiles.",
    "distributorInfo": "Información para distribuidores",
    "loading": "Cargando información de distribuidor…",
    "loadError": "No se pudo cargar la información de distribuidor."
  },
  "licenses": {
    "noneAvailable": "Actualmente, usted no tiene licencias disponibles para enviar.",
    "availableCount": "Usted tiene {{count}} licencias disponibles para enviar.",
    "boughtAndSent": "En total, usted ha comprado {{bought}} licencias y ha enviado {{sent}} licencias",
    "statAvailable": "Disponibles para enviar",
    "statBought": "Compradas",
    "statSent": "Enviadas",
    "sentHistory": "Licencias enviadas",
    "activatedYes": "Activada",
    "buyTitle": "Portal de Distribuidores - Comprar licencias",
    "buyLoading": "Cargando…",
    "buyLoadError": "No se pudo cargar la información de distribuidor.",
    "buyIntro": "Especifique cuantas licencias desea comprar - el precio de venta a distribuidores es de {{price}} pesos. Los distribuidores pueden vender DinLabel de la manera que consideren apropiada, pero nuestro precio recomendado es de {{recommended}} pesos.",
    "licenseCountLabel": "Número de licencias",
    "costSummary": "El costo de {{count}} licencias es de {{cost}} pesos + impuestos.",
    "buyButton": "Comprar {{count}} licencias",
    "sendTitle": "Enviar licencia",
    "resendConfirm": "Deseas reenviar la licencia a {{email}}?",
    "sendPrompt": "Ingresa el correo al que deseas enviar",
    "emailPlaceholder": "correo@ejemplo.com",
    "errorTitle": "Error!",
    "sendError": "Hubo un error al enviar la licencia {{error}}",
    "resentTitle": "Licencia reenviada!",
    "resentMessage": "La licencia ha sido reenviada a {{email}} con copia a {{cc}}",
    "sentTitle": "Licencia enviada!",
    "sentMessage": "La licencia ha sido enviada a {{email}} con copia a {{cc}}",
    "sendToEmail": "Enviar licencia a correo...",
    "recipient": "Recipiente de licencia",
    "date": "Fecha",
    "sent": "Enviada",
    "activated": "Activada",
    "notActivated": "Aún no activada",
    "resend": "Reenviar licencia"
  },
  "register": {
    "title": "Conviértete en distribuidor",
    "intro": "Para acceder al portal de distribuidores DinLabel, debe primero registrarse:",
    "company": "Empresa",
    "companyPlaceholder": "Nombre de empresa",
    "phone": "Teléfono",
    "phonePlaceholder": "Telefono",
    "phoneDescription": "Asegurese de incluir el código de su pais, por ejemplo +52 8183...",
    "street": "Calle",
    "street1Placeholder": "Calle1",
    "street2Placeholder": "Calle2",
    "number": "Número",
    "city": "Ciudad",
    "state": "Estado",
    "country": "País",
    "zip": "Código postal",
    "rfc": "RFC",
    "nextSteps": "Recibira un correo con los suguientes pasos",
    "submit": "Submit"
  },
  "faq": {
    "qGoogleAccount": "¿Necesito una cuenta de Google para ser distribuidor de DINLabel?",
    "aGoogleAccount": "Si es necesario que tengas una cuenta de Google, si ya cuentas con una la puedes usar para ingresar al portal de distribuidores.",
    "qRequirements": "¿Qué necesito para ser distribuidor de DINLabel?",
    "aRequirementsBefore": "Registrarte como distribuidor en el",
    "aRequirementsLink": "portal de distribuidores",
    "aRequirementsAfter": "y esperar a recibir el correo de confirmación autorizándote como distribuidor de DINLabel.",
    "qAnyoneCanSell": "¿Cualquier persona o empresa puede vender DINLabel?",
    "aAnyoneCanSell": "Si, solo debe registrarse en el portal de distribuidores de DINLabel y recibir el correo de confirmación.",
    "qHowManyDistributors": "¿Cuántos distribuidores puede haber en DINLabel?",
    "aHowManyDistributors": "No hay límite.",
    "qDistributorCost": "¿Cuánto le cuesta a un distribuidor una licencia de DINLabel?",
    "aDistributorCost": "112 dlls mas impuestos por cada licencia.",
    "qRecommendedPrice": "¿Cuál es el precio recomendado de venta del distribuidor a sus clientes por una licencia de DINLabel?",
    "aRecommendedPrice": "El precio lo define el distribuidor, no hay un precio establecido, sugerimos un precio de venta de 160 dlls mas impuestos. El precio de venta directamente en el portal de DINLabel, sin la intervención de un distribuidor es de 180 dlls.",
    "qWhereToBuy": "¿En donde puede comprar el usuario final una licencia de DINLabel?",
    "aWhereToBuyBefore": "Puede comprarla con un distribuidor o directamente en el portal",
    "qHowBuyAsDistributor": "¿Como distribuidor, como compro licencias de DINLabel?",
    "aHowBuyAsDistributorBefore": "A través del Portal de distribuidores, accediendo a la sección Comprar Licencias, consulta el tutorial",
    "aHowBuyAsDistributorLink": "como comprar licencias.",
    "qMinimumLicenses": "Como distribuidor, al comprar licencias para luego venderlas a mis clientes ¿Cuál es el mínimo de licencias que debo comprar?",
    "aMinimumLicenses": "No hay un mínimo, se puede comprar desde 1 licencia.",
    "qHowDeliver": "Como Distribuidor, ¿como le entrego a mi cliente una licencia de DINLabel?",
    "aHowDeliverBefore": "A través del portal de distribuidores, en la sección de",
    "aHowDeliverSendLink": "enviar licencias",
    "aHowDeliverMiddle": ", consulte el",
    "aHowDeliverTutorialLink": "tutorial de como enviar licencias.",
    "qHowLongPurchase": "¿Cuánto tiempo toma comprar una licencia como distribuidor y entregarla al cliente?",
    "aHowLongPurchase": "Si ya estás registrado como distribuidor en cuestión de minutos se puede hacer la compra y el envío de la licencia.",
    "qHowLongToSell": "Como distribuidor, ¿Cuánto tiempo tengo para vender las licencias que adquiera en el portal?",
    "aHowLongToSell": "Las licencias del distribuidor no caducan, al comprar licencias se agregan al inventario de licencias del distribuidor y se puede disponer de ellas en cualquier momento.",
    "qHowManyAvailable": "¿Cómo puedo saber cuantas licencias tengo como distribuidor?",
    "aHowManyAvailableBefore": "Al ingresar al",
    "aHowManyAvailableLink": "portal de distribuidores",
    "aHowManyAvailableAfter": "de DINLabel, en la primera pantalla te mostrará tu saldo de licencias disponibles para enviar.",
    "qSoldLicenses": "¿Cómo puedo saber qué licencias he vendido y a quien se las he vendido?",
    "aSoldLicensesBefore": "A través del portal de distribuidores de DINLabel en la sección",
    "aSoldLicensesLink": "ver detalles",
    "qTryBefore": "¿Puedo probar DINLabel antes de hacerme distribuidor?",
    "aTryBeforeBefore": "Si, puedes descargar una Demo en",
    "aTryBeforeAfter": "y probarla.",
    "qMainFaq": "¿Hay FAQ’s (preguntas frecuentes) para consultar en el portal DINLabel?",
    "aMainFaqBefore": "En",
    "aMainFaqAfter": "encontrarás las pregutas mas frequentes sobre el uso del sistema DINLabel.",
    "qTutorials": "¿Hay tutoriales para el uso del DINLabel?",
    "aTutorialsBefore": "En",
    "aTutorialsAfter": "encontrarás todos los tutoriales necesarios para el uso del DINLabel.",
    "qSupport": "¿Como distribuidor, tengo soporte técnico?",
    "aSupport": "Por correo electrónico, ver el final de estas FAQ.",
    "qOtherQuestion": "Tengo una duda y no se encuentra en la lista. ¿Qué puedo hacer?",
    "aOtherQuestionBefore": "Nos encantaría ayudarte. Ir a",
    "aOtherQuestionLink": "contáctanos",
    "aOtherQuestionAfter": ", envía tus dudas y con gusto te respondemos."
  },
  "tutorials": {
    "title": "Tutoriales",
    "alsoSeeFaqBefore": "Tambien puede ver la página de",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutorial: Como enviar una licencia desde el portal de distribuidores",
    "iframeTitle": "Tutorial enviar licencia"
  },
  "home": {
    "welcome": "Welcome, {{name}}",
    "error": "Error"
  },
  "buy": {
    "welcome": "Bienvenid@, {{name}}"
  },
  "userLicenses": {
    "hasLicense": "Usted ya tiene una licencia de DinLabel.",
    "noLicense": "Usted no ha adquirido su licencia de DinLabel",
    "buyHere": "Adquierala Aqui"
  },
  "app": {
    "documentTitle": "DinLabel"
  },
  "signin": {
    "title": "Iniciar sesión",
    "intro": "Inicia sesión con tu cuenta de Google para continuar.",
    "withGoogle": "Iniciar sesión con Google",
    "agreePrefix": "Al continuar aceptas nuestra",
    "privacyLink": "Política de privacidad y términos de servicio",
    "alreadySignedIn": "Ya has iniciado sesión",
    "signedInAs": "Sesión iniciada como {{email}}",
    "continue": "Continuar",
    "debugSignInUrl": "URL de inicio de sesión"
  },
  "marketing": {
    "headline": "Software profesional para diseño de etiquetas",
    "slogan": "Diseña, imprime y administra etiquetas con códigos de barras, datos variables y más.",
    "featureNumbers": "Números consecutivos",
    "featureImages": "Imágenes",
    "featureVariable": "Datos variables",
    "featureQr": "Código 2D",
    "featureText": "Texto",
    "featureBarcode": "Código de barras",
    "featuresTitle": "Todo lo que necesitas en una etiqueta",
    "featuresSubtitle": "Crea etiquetas profesionales con las herramientas que usan imprentas y almacenes cada día.",
    "whyTitle": "¿Por qué DinLabel?",
    "whyBody": "DinLabel te ayuda a crear etiquetas profesionales rápidamente para rollos, planillas e impresoras industriales.",
    "tryTitle": "Prueba la demo de DinLabel",
    "trySubtitle": "Descarga la versión demo y empieza a diseñar etiquetas en minutos.",
    "needHelp": "¿Necesitas ayuda?",
    "customerService": "Servicio al cliente",
    "customerServiceText": "Contáctanos por correo y con gusto te ayudamos.",
    "tutorialsText": "Tutoriales en video paso a paso para cada función."
  },
  "footer": {
    "tagline": "Diseño profesional de etiquetas para rollos, planillas e impresoras industriales.",
    "privacy": "Privacidad y términos",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Descargar",
    "intro": "Instala DinLabel en Windows y empieza a diseñar etiquetas profesionales en minutos.",
    "windowsNote": "Instalador de Windows (.exe). Compatible con Windows 7 y posteriores.",
    "requirements": "Requisitos del sistema",
    "reqWindows": "Compatible con cualquier version de Windows a partir de Windows 7",
    "reqInternet": "Acceso a Internet",
    "reqRam": "1 GB de RAM",
    "reqDisk": "10 GB de espacio disponible en disco duro",
    "freeTag": "Versión demo",
    "freeText": "La versión demo incluye una marca de agua en las etiquetas impresas.",
    "paidTitle": "Versión completa",
    "paidText": "Sin marcas de agua — lista para impresión de producción.",
    "buyApp": "Comprar la aplicación",
    "orDistributor": "¿Prefieres comprar a través de un socio?",
    "distributorsLink": "Ver distribuidores"
  },
  "fullTutorials": {
    "title": "Tutoriales",
    "intro": "Videos paso a paso para diseñar, imprimir y aprovechar DinLabel al máximo.",
    "howToRoll": "Cómo crear una etiqueta en rollo",
    "howToSheet": "Cómo crear una etiqueta en planilla",
    "howTo3Across": "Cómo crear etiquetas de 3 al paso",
    "howToText": "Cómo agregar texto",
    "howToShapes": "Cómo agregar figuras",
    "howToImages": "Cómo agregar imágenes",
    "howToBarCodes": "Cómo agregar códigos de barras",
    "howToQR": "Cómo agregar códigos QR",
    "howToPrint": "Cómo imprimir",
    "howToConsecutive": "Cómo usar números consecutivos",
    "howToDataBase": "Cómo usar bases de datos",
    "howToBuy": "Cómo comprar DinLabel",
    "alsoDistributor": "Los tutoriales para distribuidores están en el portal de distribuidores.",
    "distributorLink": "Abrir portal de distribuidores"
  },
  "privacy": {
    "title": "Política de privacidad y términos de servicio",
    "eulaLink": "Contrato de licencia de usuario final",
    "policyLink": "Política de privacidad",
    "note": "La política de privacidad abre el documento HTML estático localizado.",
    "loading": "Cargando…",
    "eulaLoadError": "No se pudo cargar el EULA."
  },
  "distributors": {
    "title": "Distribuidores"
  },
  "buyPage": {
    "title": "Comprar DinLabel",
    "intro": "Desbloquea la versión completa — sin marcas de agua, lista para impresión de producción.",
    "panelTitle": "Licencia de versión completa",
    "loading": "Cargando pago…",
    "loadError": "No se pudo iniciar el pago. Inicia sesión e inténtalo de nuevo.",
    "errorTitle": "Algo salió mal",
    "thanks": "¡Tienes la versión completa de DinLabel!",
    "checkAccount": "Revisa el estado de tu cuenta",
    "price": "USD ${{price}} + Impuestos",
    "payWithCard": "Pagar con tarjeta",
    "payError": "No se pudo redirigir a Stripe.",
    "orVia": "¿Prefieres otra opción?",
    "downloadDemo": "Descargar una demo completamente funcional",
    "contactDistributor": "Contactar a un distribuidor",
    "becomeDistributor": "¿Quieres ser distribuidor?"
  },
  "userInfo": {
    "title": "Mi cuenta",
    "detailsTitle": "Datos de la cuenta",
    "quickLinks": "Enlaces rápidos",
    "userId": "ID de usuario",
    "name": "Tu nombre",
    "email": "Correo electrónico",
    "emailConfirmed": "Correo confirmado",
    "confirmed": "Confirmado",
    "notConfirmed": "Sin confirmar",
    "resend": "Reenviar",
    "resentEmail": "Correo de confirmación reenviado a {{email}}",
    "resendError": "No se pudo reenviar el correo de confirmación.",
    "version": "Versión de la aplicación",
    "freeVersion": "Versión demo",
    "fullVersion": "Versión completa",
    "buyApp": "Comprar la aplicación",
    "accountType": "Cuenta",
    "admin": "Portal de administración",
    "openDistributorPortal": "Abrir portal de distribuidores"
  },
  "myLabels": {
    "title": "Mis etiquetas",
    "loading": "Cargando…",
    "loadError": "No se pudieron cargar las etiquetas.",
    "empty": "No tienes etiquetas guardadas.",
    "name": "Nombre",
    "date": "Fecha",
    "view": "Ver",
    "download": "Descargar",
    "back": "Volver a mis etiquetas"
  },
  "admin": {
    "title": "Portal de administración",
    "dataLink": "Herramientas de datos",
    "fakeEmailLink": "Correos falsos",
    "loading": "Cargando…",
    "loadError": "No se pudieron cargar los datos de administración.",
    "totalUsers": "Usuarios totales: {{count}}",
    "paidUsers": "Usuarios de pago: {{count}}",
    "users": "Usuarios",
    "distributors": "Distribuidores",
    "payments": "Pagos de distribuidores",
    "authorize": "Autorizar"
  },
  "fakeEmail": {
    "title": "Correos falsos",
    "description": "Vista previa de plantillas de correo con datos de ejemplo.",
    "distributorSignUp": "Registro de distribuidor",
    "activationLink": "Activación / confirmar correo",
    "sendEmailLicense": "Distribuidor envía licencia",
    "congratulationEmail": "Felicitaciones",
    "boughtLicensesMail": "Licencias compradas",
    "subject": "Asunto",
    "body": "Cuerpo",
    "loading": "Cargando…",
    "loadError": "No se pudo cargar este correo.",
    "backAdmin": "Volver a administración"
  }
}
